import Core from '../Core/Core';
import { IEntryPointData } from '../SDK/SDK';
import getLogger, { ILogger } from '../Core/Logger';

const logger: ILogger = getLogger('[Platform]: ');

export default {
    fbinstant: {
        game: {
            id: 'moji',
        },
        modules: ['basic', 'gameBackend', 'levelGame', 'social', 'leaderboard'],
        build: VERSION,
        doNotWaitForGbConnection: true,
        logLevel: -1,
        supportedLanguages: [
            'en',
            'de',
            'es',
            'fr',
            'it',
            'pt',
            'ru',
            'tr',
            'nl',
            'pl',
            'vi',
            'hi',
            'pt-BR',
            'th',
        ],
        commands: {
            basic: {
                freezeGame: () => {
                    Core.sdk.freezeGame(); // move away from statics so it can update state...
                    // execute game specific functions to freeze the game
                },
                unfreezeGame: () => {
                    Core.sdk.unFreezeGame();
                    // execute game specific functions to unfreezeGame the game
                },
                runGame: () => {
                    // setup(); calling this here does not have the user set in the loadComplete handler in sdkwrapper
                    // execute game specific functions start the game, this will be executed after loading completed is called
                },

                setEntryPointData: (data: IEntryPointData) => {
                    Core.sdk.messages.setEntryPointData(data).catch(err => {
                        logger.debug('error with entry point data: ' + err + ', with: ' + data);
                    });
                },

                changeLocale: (locale: string) => {
                    // Core.changeLocale(locale);
                },
            },
        },
    },
};
